export const formatUTC = 'YYYY-MM-DDTHH:mm:00[Z]';
export const formatUTCNoOffset = 'YYYY-MM-DDTHH:mm:00';
export const formatUTCNoMinOffset = 'YYYY-MM-DDTHH:00:00';
